<template>
  <MainLayout>
    <ReservationPayment />
  </MainLayout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';
import ReservationPayment from '@/components/reserve/ReservationPayment.vue';

export default {
  name: 'ReservationPaymentView',
  components: {
    MainLayout,
    ReservationPayment,
  },
};
</script>
